function initializeObservers() {
  const images = document.querySelectorAll(".fade-in:not([data-observed])");
  const lazyVideos = document.querySelectorAll(".js-lazy-video:not([data-observed])");

  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        imageObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  images.forEach((img) => {
    img.setAttribute("data-observed", "true");
    imageObserver.observe(img);
  });

  const loadVideoSources = (video) => {
    const sources = video.querySelectorAll("source[data-src]");

    video.controls = false;

    // Safari gates autoplay on the element's live properties rather than the
    // attributes it parsed, and load() below resets the element, so mirror the
    // markup here before asking it to play.
    video.muted = true;
    video.playsInline = true;

    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
    });

    if (sources.length > 0) {
      video.load();
    }

    if (video.hasAttribute("autoplay")) {
      const playVideo = () => {
        if (!video.paused) {
          return;
        }

        const playPromise = video.play();

        if (playPromise && typeof playPromise.then === "function") {
          playPromise.catch(() => {});
        }
      };

      // Safari will not buffer past metadata on its own, so gating the first
      // play() on readyState 2 deadlocks: the frame it waits for only arrives
      // once playback starts. Ask straight away and retry as the element
      // reports itself playable, for browsers that do prebuffer.
      playVideo();
      video.addEventListener("loadeddata", playVideo, { once: true });
      video.addEventListener("canplay", playVideo, { once: true });
    }
  };

  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;

          loadVideoSources(video);

          videoObserver.unobserve(video);
        }
      });
    });

    lazyVideos.forEach((video) => {
      video.setAttribute("data-observed", "true");
      videoObserver.observe(video);
    });
  } else {
    lazyVideos.forEach((video) => {
      loadVideoSources(video);
      video.setAttribute("data-observed", "true");
    });
  }
}

// Markup injected after load needs these observers wired too. .fade-in starts at opacity 0
// and only becomes visible once the observer adds .show, so anything fetched later — the cart
// drawer's upsell and empty-cart products, filtered collection pages, predictive search —
// stays permanently invisible without this. The :not([data-observed]) guard above means
// re-running it is cheap and never double-observes.
window.initializeLazyObservers = initializeObservers;

document.addEventListener("DOMContentLoaded", initializeObservers);
document.addEventListener("shopify:section:load", initializeObservers);
document.addEventListener("shopify:section:select", initializeObservers);
document.addEventListener("shopify:block:select", initializeObservers);